import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-795e60df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "material-icons" }
const _hoisted_2 = {
  key: 0,
  class: "controls"
}
const _hoisted_3 = { class: "controls__box controls__box--axies" }
const _hoisted_4 = {
  key: 0,
  class: "select"
}
const _hoisted_5 = { class: "select__label" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "-1" }, "None", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 1,
  class: "select"
}
const _hoisted_9 = { class: "select__label" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "-1" }, "None", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 2,
  class: "select"
}
const _hoisted_13 = { class: "select__label" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "-1" }, "None", -1))
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "controls__box--long" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controls__box--long__title" }, "Settings", -1))
const _hoisted_18 = { class: "controls__box--long__content" }
const _hoisted_19 = {
  key: 0,
  class: "checkbox"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__mark" }, null, -1))
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = { class: "checkbox__text" }
const _hoisted_23 = {
  key: 1,
  class: "slider",
  for: ""
}
const _hoisted_24 = { class: "slider__name" }
const _hoisted_25 = { class: "slider__value" }
const _hoisted_26 = { class: "slider__wrapper" }
const _hoisted_27 = { class: "slider__clamp" }
const _hoisted_28 = ["min", "max", "onUpdate:modelValue"]
const _hoisted_29 = { class: "slider__clamp" }
const _hoisted_30 = {
  key: 2,
  class: "input",
  for: ""
}
const _hoisted_31 = { class: "input__name" }
const _hoisted_32 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: "controls-min button--icon",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleControls && _ctx.toggleControls(...args)))
    }, [
      _createElementVNode("i", _hoisted_1, _toDisplayString(_ctx.controls ? "expand_more" : "expand_less"), 1)
    ]),
    (_ctx.controls)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.graphType.axisNames[0])
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.graphType.axisNames[0]), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "select__input",
                    name: "",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.graphData.xAxis) = $event))
                  }, [
                    _hoisted_6,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentData.cols, (col, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: index,
                        key: index
                      }, _toDisplayString(col), 9, _hoisted_7))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.graphData.xAxis]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.graphType.axisNames[1])
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.graphType.axisNames[1]), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "select__input",
                    name: "",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.graphData.yAxis) = $event))
                  }, [
                    _hoisted_10,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentData.cols, (col, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: index,
                        key: index
                      }, _toDisplayString(col), 9, _hoisted_11))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.graphData.yAxis]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.graphType.axisNames[2])
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.graphType.axisNames[2]), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "select__input",
                    name: "",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.graphData.zAxis) = $event))
                  }, [
                    _hoisted_14,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentData.cols, (col, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: index,
                        key: index
                      }, _toDisplayString(col), 9, _hoisted_15))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.graphData.zAxis]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.graphType.settings, (setting, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (setting.type == 'toggle')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_19, [
                        _hoisted_20,
                        _withDirectives(_createElementVNode("input", {
                          class: "checkbox__input",
                          type: "checkbox",
                          name: "",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.graphData.settings.values[setting.key]) = $event)
                        }, null, 8, _hoisted_21), [
                          [_vModelCheckbox, _ctx.graphData.settings.values[setting.key]]
                        ]),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(setting.name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (setting.type == 'slider')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, [
                          _createTextVNode(_toDisplayString(setting.name) + " ", 1),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.graphData.settings.values[setting.key]), 1)
                        ]),
                        _createElementVNode("span", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString(setting.min), 1),
                          _withDirectives(_createElementVNode("input", {
                            class: "slider__input",
                            type: "range",
                            name: "",
                            id: "",
                            min: setting.min,
                            max: setting.max,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.graphData.settings.values[setting.key]) = $event)
                          }, null, 8, _hoisted_28), [
                            [_vModelText, _ctx.graphData.settings.values[setting.key]]
                          ]),
                          _createElementVNode("span", _hoisted_29, _toDisplayString(setting.max), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (setting.type == 'number')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_30, [
                        _createElementVNode("span", _hoisted_31, _toDisplayString(setting.name), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          name: "",
                          id: "",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.graphData.settings.values[setting.key]) = $event)
                        }, null, 8, _hoisted_32), [
                          [_vModelText, _ctx.graphData.settings.values[setting.key]]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}